import { useContext } from 'react';

// Import context
import { ShakaPlayerContext } from 'components/context/player/player_vod';

export function useContextProvider() {
	const context = useContext(ShakaPlayerContext);

	return context;
}
